//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  data () {
    return {
      first_name: null,
      last_name: null,
      email: null,
      mobile: null,
      title: null,
      content: null,
      attachment: null,
      errors: null,
      success: false,
      danger: false,
      uploadStatus: false,
      requesting: false,
      fileName: null
    }
  },
  head () {
    return {
      title: this.$t('contactUs.contactUsTitle') + ' - ' + this.$t('common.arzypto'),
      meta: [
        { hid: 'description', name: 'description', content: this.$t('contactUs.contactUsTitle') }
      ],
      link: [
        { rel: 'canonical', href: 'https://www.arzypto.com/contact' }
      ]
    }
  },

  methods: {
    uploadAttachment (file) {
      const vm = this
      this.uploadStatus = true
      this.fileName = file.target.files[0].name
      vm.$upload(vm.$refs.new_ticket_attachment.files, 'attachment')
        .then((res) => {
          vm.attachment = res.data.data.file_id
          this.uploadStatus = false
        })
    },
    contactUs () {
      const form = {
        first_name: this.first_name,
        last_name: this.last_name,
        email: this.email,
        mobile: this.mobile,
        title: this.title,
        content: this.content,
        attachment: this.attachment
      }
      this.$store.dispatch('axios/post', {
        url: process.env.ASYNC_BASE_URL_API + process.env.BASE_URL_WITH_UUID + '/application/contactUs',
        data: form
      }).then(() => {
        this.errors = null
        this.danger = false
        this.success = true
        this.first_name = null
        this.last_name = null
        this.email = null
        this.mobile = null
        this.title = null
        this.content = null
        this.attachment = null
        this.fileName = null
        this.$toast.success(this.$t('contactUs.ticketIsSent'))
      }).catch((_) => {})
    }
  }
}
